// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const popSideSlice = createSlice({
  name: 'popSide',
  initialState: {
    commentsTabCount: 0,
    isPopSideOpen: false,
    summaryMarkdown: '',
    summaryAiRoleOptions: [],
    summaryAiSelectedRole: {}
  },
  reducers: {
    setCommentsTabCount(state, { payload }) {
      state.commentsTabCount = payload;
    },
    setIsPopSideOpen(state, { payload }) {
      state.isPopSideOpen = payload;
    },
    setSummaryMarkdown(state, { payload }) {
      state.summaryMarkdown = payload;
    },
    setSummaryAiRoleOptions(state, { payload }) {
      state.summaryAiRoleOptions = payload;
    },
    setSummaryAiSelectedRole(state, { payload }) {
      state.summaryAiSelectedRole = payload;
    }
  }
});

const { actions, reducer } = popSideSlice;
export const {
  setCommentsTabCount,
  setIsPopSideOpen,
  setSummaryMarkdown,
  setSummaryAiRoleOptions,
  setSummaryAiSelectedRole
} = actions;
export default reducer;
